import { useMemo } from "react";
import { analyzeWall, type WallInput, type WallResult } from "@tasduvar/engine";

export interface Analysis { result: WallResult | null; error: string | null }

export function runAnalysis(wall: WallInput | null): Analysis {
  if (!wall) return { result: null, error: null };
  try { return { result: analyzeWall(wall), error: null }; }
  catch (e) { return { result: null, error: e instanceof Error ? e.message : "Hesap yapılamadı" }; }
}

export function useAnalysis(wall: WallInput | null): Analysis {
  return useMemo(() => runAnalysis(wall), [wall]);
}
